export type VoteType = "up" | "down" | null;

export const getBadgeColor = (value: number) => {
  if (value >= 80) return "#D4FFD5";
  if (value >= 50) return "#FFF1B0";
  if (value >= 25) return "#FFE9FF";
  return "#F0F0F0";
};

export const getCurrentLiked = (liked: boolean | null | undefined): VoteType => {
  if (liked === true) return "up";
  if (liked === false) return "down";
  return null;
};

export const getConfidenceNumber = (value: unknown) => {
  if (typeof value === "number") return value;
  if (typeof value === "string")
    return parseInt(value.replace("%", ""), 10) || 0;
  return 0;
};
